import type {HTMLOcButtonV1Element} from "@otto-ec/otto-components/button";
import type {HTMLOcSheetV1Element} from "@otto-ec/otto-components/sheet";

export class PictureTextSlider {
    private readonly joinToWinButtons: HTMLOcButtonV1Element[];

    constructor() {
        this.joinToWinButtons = Array.from(
            document.querySelectorAll('.promo_staticcontent--picture-text-slider oc-sheet-v1 oc-button-v1[data-js="slider-sheet-join-to-win-button"]'),
        );

        this.setUpEventListeners();
    }

    setUpEventListeners() {
        this.joinToWinButtons.forEach((button) => {
            const sheet = button.closest<HTMLOcSheetV1Element>('oc-sheet-v1');
            if (!sheet) {
                return;
            }

            button.addEventListener('click', () => {
                sheet.close();
                sheet.addEventListener(
                    'oc-sheet-after-close',
                    () => window.scrollTo({top: 0, behavior: 'smooth'}),
                    {once: true},
                );
            });
        });
    }
}
